import { render, staticRenderFns } from "./GlobalCards.vue?vue&type=template&id=ecda4d1a&scoped=true"
import script from "./GlobalCards.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalCards.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GlobalCards.vue?vue&type=style&index=0&id=ecda4d1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecda4d1a",
  null
  
)

export default component.exports